var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"article-picker__checkmark__svg","d":"M21.5 43C9.675 43 0 33.325 0 21.5C0 9.675 9.675 0 21.5 0C33.325 0 43 9.675 43 21.5C43 33.325 33.325 43 21.5 43ZM21.5 1.95455C10.75 1.95455 1.95455 10.75 1.95455 21.5C1.95455 32.25 10.75 41.0455 21.5 41.0455C32.25 41.0455 41.0455 32.25 41.0455 21.5C41.0455 10.75 32.25 1.95455 21.5 1.95455Z","key":0}),React.createElement("path",{"className":"article-picker__checkmark__svg","d":"M8.50227 17.7864L0 9.28409L1.36818 7.81818L8.50227 14.9523L23.4545 0L24.8227 1.46591L8.50227 17.7864Z","transform":"translate(9.08864 13.5841)","key":1})]);
}

Checkmark.defaultProps = {"viewBox":"0 0 43 43","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
